module.exports = __webpack_public_path__ + "public/img/shangyuekaijilvtubiao.137b98c2.png";